import { gql } from "@apollo/client";
import { BasicQueryInfoInput } from "../../FeedDataCalls/GQLCalls/getFeedComponentsCall";

export interface DeviceChangeQueueInfo {
    lan_controller_id: number
	lan_controller_cpu_id: string
    message_count: number
    oldest_message_timestamp?: string
    error_occurred: boolean
}

export const DEVICE_CHANGE_QUEUE_INFO = gql`
query DeviceChangeQueueInfo($domain: String!, $input: BasicQueryInfoInput!) {
	controller {
		deviceChangeQueueInfo(domain: $domain, input: $input) {
			lan_controller_id
			lan_controller_cpu_id
			message_count
			oldest_message_timestamp
			error_occurred
		}
	}
}
`

export interface DeviceChangeQueueInfoResponse {
	controller: {
		deviceChangeQueueInfo: DeviceChangeQueueInfo[]
	}
}

export interface DeviceChangeQueueInfoArgs {
	domain: string;
	input: BasicQueryInfoInput;
}

